import { useId } from "react";

type Props = {
  label: string;
  description?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
};

export function SettingsToggle({ label, description, checked, onChange }: Props) {
  const descriptionId = useId();
  return (
    <label className="settings-toggle">
      <span className="settings-toggle-copy">
        <span className="settings-toggle-label">{label}</span>
        {description ? <small id={descriptionId}>{description}</small> : null}
      </span>
      <input
        type="checkbox"
        checked={checked}
        onChange={event => onChange(event.target.checked)}
        aria-label={label}
        aria-describedby={description ? descriptionId : undefined}
      />
      <span className="settings-switch" aria-hidden="true" />
    </label>
  );
}
